module.exports = __webpack_public_path__ + "img/KL.95582c8d.jpg";